import { gtmEvent, filterUndefinedAndEmptyValues } from '../../utils/gtmEvents';
const gtmOwnerManuals = ({ ctaPlacement, componentType, model, year, clickedText, title, listName, ctaType, trim, bodyStyle, linkURL, }) => {
    const gtmPayload = {
        event: 'cta_click',
        cta_type: ctaType,
        cta_placement: ctaPlacement,
        list_name: listName,
        link_text: clickedText,
        component_type: componentType,
        body_style: bodyStyle,
        link_url: linkURL,
        model,
        year,
        title,
        trim,
    };
    const filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
export default gtmOwnerManuals;
